<div class="flex h-screen overflow-hidden bg-surface-bg">
  @if (isMobile()) {
    <!-- Móvil: el menú no ocupa ancho; se abre como panel superpuesto desde la barra superior. -->
    @if (mobileMenuOpen()) {
      <app-sidebar
        mode="overlay"
        [items]="filteredMenu()"
        [activeUrl]="activeUrl()"
        [user]="sidebarUser()"
        [searchTerm]="searchTerm()"
        (closeRequest)="closeMobileMenu()"
        (searchTermChange)="searchTerm.set($event)"
        (logout)="onLogout()"
      />
    }
  } @else {
    <app-sidebar
      [items]="filteredMenu()"
      [collapsed]="collapsed()"
      [activeUrl]="activeUrl()"
      [user]="sidebarUser()"
      [searchTerm]="searchTerm()"
      (toggleCollapse)="onToggleCollapse()"
      (searchTermChange)="searchTerm.set($event)"
      (logout)="onLogout()"
    />
  }

  <div class="flex min-w-0 flex-1 flex-col overflow-hidden">
    <app-header
      [title]="headerTitle()"
      [badge]="headerBadge()"
      [showMenuButton]="isMobile()"
      [menuExpanded]="mobileMenuOpen()"
      (menuToggle)="openMobileMenu()"
      (logout)="onLogout()"
    >
      <app-notification-bell-container headerActions />
    </app-header>

    <main class="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto p-3">
      <router-outlet />
    </main>
  </div>
</div>
